import { ACCOUNT_INFO_DATA, ADD_ACCOUNT_DATA, DELETE_SOCIAL_ACCOUNT_DATA, PROD_SUBSCRIPTION, SOCIAL_ACCOUNT_DATA, UGC_ADDON_DATA, WIDGET_ADDON_DATA, } from "../reducers/keys";
import { TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS } from "../utils";
import { DELETE_SOCIAL_ACCOUNT_URL, DOWNLOAD_INVOICE_PDF_URL, GET_ADD_ACCOUNT_LIST, GET_USER_ACCOUNT_INFO, GET_USER_PROD_SUBSCRIPTION, GET_USER_SOCIAL_ACCOUNT, SOCIAL_SHARE_CONNECTION_URL, GET_USER_WIDGET_ADDON_DATA, GET_USER_UGC_ADDON_DATA, MFA_ENABLE, MFA_VERIFY, TIKTOK_HASHTAG_ID } from "./api";
import HttpClient from "./http-client";
import { checkLoginToken } from "./loginActions";



export const getUserInfo = () => {
    return (dispatch) => {
        new HttpClient().get(`${GET_USER_ACCOUNT_INFO}?type=4`).then((res) => {
            const { data } = res;

            if (data.responseData) dispatch({ type: ACCOUNT_INFO_DATA, payload: data.responseData });
        }).catch(ex=>{
            checkLoginToken(ex);
        });
    };
};

export const GET_PROD_SUBSCRIPTION = () => {
    return (dispatch) => {
        new HttpClient().get(`${GET_USER_PROD_SUBSCRIPTION}?type=4`).then((res) => {
            const { data } = res;
            if (data.responseData) dispatch({ type: PROD_SUBSCRIPTION, payload: data.responseData });
        });
    };
};
export const GET_WIDGET_ADDON_SUBSCRIPTION_DATA = () => {
    return (dispatch) => {
        new HttpClient().get(GET_USER_WIDGET_ADDON_DATA).then((res) => {
            const { data } = res;
            if (data.responseData) dispatch({ type: WIDGET_ADDON_DATA, payload: data.responseData });
        });
    };
};
export const GET_UGC_ADDON_SUBSCRIPTION_DATA = () => {
    return (dispatch) => {
        new HttpClient().get(GET_USER_UGC_ADDON_DATA).then((res) => {
            const { data } = res;
            if (data.responseData) dispatch({ type: UGC_ADDON_DATA, payload: data.responseData });
        });
    };
};

export const DOWNLOAD_INVOICE_PDF = (invoiceId) => {
    return new HttpClient().get(`${DOWNLOAD_INVOICE_PDF_URL}/${invoiceId}`, {
        responseType: "arraybuffer",
        headers: { Accept: "application/pdf" },
    });
};

export const GET_SOCIAL_ACCOUNT_DATA = (ownerId=localStorage.getItem('ownerId'),callback) => {
    return (dispatch) => {
        new HttpClient() .get(`${GET_USER_SOCIAL_ACCOUNT}?ownerId=${ownerId}`) .then((res) => {
                const { data } = res;
                  if(callback){ callback(); }
                dispatch({ type: SOCIAL_ACCOUNT_DATA, payload: data.responseData, });
            })
            .catch((error) => {

            });
    };
};

export const DELETE_USER_SOCIAL_ACCOUNT = (feedId, networkId, callBack) => {
    return (dispatch) => {
        new HttpClient() .get(`${DELETE_SOCIAL_ACCOUNT_URL}/${feedId}/${networkId}`) .then((response) => {
                const { responseCode } = response.data;
                if (responseCode == 200) dispatch({ type: DELETE_SOCIAL_ACCOUNT_DATA, payload: { feedId: feedId, networkId: networkId } });
                callBack(null);
            }).catch((error) => {
                if(error && error.response && error.response.data && Object.keys(error.response.data).length > 0){
                    const { responseMessage, responseStatus } = error.response.data;
                    if(responseStatus == "error") callBack(responseMessage);
                }
            });
    };
};

export const SOCIAL_ACCOUNT_ADD_ACCOUNT_DATA = () => {
    return (dispatch) => {
        new HttpClient() .get(GET_ADD_ACCOUNT_LIST) .then((response) => {
                const { responseData } = response.data;
                dispatch({ type: ADD_ACCOUNT_DATA, payload: responseData, });
            })
            .catch((error) => {

            });
    };
};

export const SHARE_CONNECTION_URL = (data) => new HttpClient().post(`${SOCIAL_SHARE_CONNECTION_URL}`, data);

export const ENABLE_MFA = (data) => new HttpClient().post(MFA_ENABLE, data);
export const TIKTOK_HASHTAG_ID_URL = (data) => new HttpClient().post(`${TIKTOK_HASHTAG_ID}`, data);
